"use client";

import React from "react";
import Image from "next/image";

interface TeamMember {
  name: string;
  role: string;
  imageSrc: string;
  imageAlt: string;
}

const teamMembers: TeamMember[] = [
  {
    name: "Samantha",
    role: "Receptionist",
    imageSrc: "/images/team-samantha.webp",
    imageAlt: "Photo of Samantha, Receptionist at Smile4Me Dental Care",
  },
  {
    name: "Veronica",
    role: "Head Assistant",
    imageSrc: "/images/team-veronica.webp",
    imageAlt: "Photo of Veronica, Head Assistant at Smile4Me Dental Care",
  },
  {
    name: "Vanessa",
    role: "Dental Assistant",
    imageSrc: "/images/team-vanessa.webp",
    imageAlt: "Photo of Vanessa, Dental Assistant at Smile4Me Dental Care",
  },
  {
    name: "Ximena",
    role: "Dental Assistant",
    imageSrc: "/images/team-ximena.webp",
    imageAlt: "Photo of Ximena, Dental Assistant at Smile4Me Dental Care",
  },
  {
    name: "Dilara",
    role: "Dental Assistant",
    imageSrc: "/images/custom_images_team_dilara.webp",
    imageAlt: "Photo of Dilara, Dental Assistant at smile4me",
  },
  {
    name: "Almira",
    role: "Manager / Treatment Coordinator",
    imageSrc: "/images/custom_images_team_almira.webp",
    imageAlt: "Photo of Almira, Manager & Treatment Coordinator at smile4me",
  },
  {
    name: "Ina",
    role: "Marketing",
    imageSrc: "/images/custom_images_team_ina2.webp",
    imageAlt: "Photo of Ina, Marketing at smile4me",
  },
  {
    name: "Stephanie",
    role: "Front Desk",
    imageSrc: "/images/custom_images_team_stephanie.webp",
    imageAlt: "Photo of Stephanie, Front Desk Receptionist at smile4me",
  },
];

const OurTeam: React.FC = () => {
  return (
    <>
      <section
        className="relative w-full bg-gradient-to-br from-gray-50 to-white pt-32 pb-12 sm:pt-36 sm:pb-16 overflow-hidden"
        role="region"
        aria-labelledby="team-heading"
      >
        {/* Decorative background elements - matching other components */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-[#ECD05B]/10 to-transparent rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-[#AE7D2F]/10 to-transparent rounded-full blur-3xl" />

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
          <h1
            id="team-heading"
            className="
            text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-900 text-center
            after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:my-5
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
            mb-16
          "
          >
            Meet Our Astoria Dental Team
          </h1>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 md:gap-10 max-w-5xl mx-auto">
            {teamMembers.map((member) => (
              <div
                key={member.name}
                className="flex flex-col items-center cursor-pointer group"
                onClick={() => console.log(`${member.name} clicked`)}
              >
                {/* Hexagon container */}
                <div className="relative w-[140px] h-[161px] sm:w-[160px] sm:h-[184px] md:w-[180px] md:h-[207px] mx-auto">
                  {/* Gradient border */}
                  <div
                    className="absolute inset-0 bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] group-hover:from-[#ECD05B] group-hover:via-[#AE7D2F] group-hover:to-[#ECD05B] transition-all duration-300"
                    style={{
                      clipPath:
                        "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)",
                    }}
                  />
                  {/* Inner white background */}
                  <div
                    className="absolute inset-[5px] bg-white"
                    style={{
                      clipPath:
                        "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)",
                    }}
                  >
                    {/* Image */}
                    <div className="relative w-full h-full overflow-hidden">
                      <Image
                        src={member.imageSrc}
                        alt={member.imageAlt}
                        fill
                        className="object-cover group-hover:scale-110 transition-transform duration-300"
                        style={{
                          clipPath:
                            "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)",
                        }}
                        sizes="(max-width: 640px) 140px, (max-width: 768px) 160px, 180px"
                      />
                    </div>
                  </div>
                </div>

                {/* Text below hexagon */}
                <div className="text-center mt-4">
                  <h3 className="text-lg sm:text-xl font-semibold text-gray-900 group-hover:text-[#d5ac26] transition-colors duration-300">
                    {member.name}
                  </h3>
                  <p className="text-sm sm:text-base text-gray-600">
                    {member.role}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default OurTeam;
